import { ListChecks, SealCheck, Scales, ShieldCheck, Flag, Check } from "@phosphor-icons/react";

// Compact 5-step month-end progress for a single client, used on the Command Centre
// so partners can spot who's stuck at a glance. Each segment links into that client.
export function clientSteps(e) {
  const overdue = e.journals_overdue || 0;
  // Postable now (matches the Close page), not just journals due later this month.
  const post = e.journals_to_post != null ? e.journals_to_post : ((e.journals_due || 0) + overdue);
  return [
    { key: "review", label: "Review", icon: ListChecks, count: e.unscheduled || 0,
      done: (e.unscheduled || 0) === 0, to: "/unscheduled" },
    { key: "post", label: "Post", icon: SealCheck, count: post, urgent: overdue > 0,
      done: post === 0, to: "/close", dueLater: e.journals_due_later || 0 },
    { key: "reconcile", label: "Reconcile", icon: Scales, count: e.variances || 0,
      done: (e.variances || 0) === 0, to: "/reconciliation" },
    { key: "approve", label: "Approve", icon: ShieldCheck, count: e.approvals_waiting || 0,
      done: (e.approvals_waiting || 0) === 0, to: "/approvals" },
    { key: "signoff", label: "Sign-off", icon: Flag, count: 0,
      done: e.month_end?.state === "signed_off", to: "/close" },
  ];
}

export default function ClientJourney({ entity, onStep }) {
  const steps = clientSteps(entity);
  const currentIdx = steps.findIndex((s) => !s.done);
  return (
    <div className="flex items-center gap-1" data-testid={`cc-journey-${entity.tenant_id}`}>
      {steps.map((s, i) => {
        const Icon = s.icon;
        const isCurrent = i === currentIdx;
        const state = s.done ? "done" : isCurrent ? "current" : "todo";
        const cls = {
          done: "border-positive/30 bg-positive/[0.08] text-positive",
          current: s.urgent ? "border-negative/50 bg-negative/[0.06] text-negative ring-1 ring-negative/30" : "border-orange/60 bg-orange/[0.08] text-orangeink ring-1 ring-orange/25",
          todo: "border-slate-200 bg-white text-navy/35 hover:border-navy/30",
        }[state];
        return (
          <button key={s.key} onClick={() => onStep?.(s)} data-testid={`cc-journey-${entity.tenant_id}-${s.key}`}
            title={`${s.label}${s.count > 0 ? ` · ${s.count} to do` : s.done ? " · clear" : ""}${s.dueLater > 0 ? ` · ${s.dueLater} due later this month` : ""}`}
            className={`group flex items-center gap-1 rounded-lg border px-2 py-1 transition-colors ${cls}`}>
            {s.done ? <Check size={12} weight="bold" /> : <Icon size={12} weight={isCurrent ? "fill" : "regular"} />}
            <span className="text-[0.62rem] font-semibold hidden xl:inline">{s.label}</span>
            {s.count > 0 && (
              <span className={`text-[0.6rem] font-bold tabular ${s.urgent ? "text-negative" : "text-orangeink"}`}>{s.count}</span>
            )}
            {s.count === 0 && s.dueLater > 0 && (
              <span className="text-[0.58rem] font-medium text-navy/35 tabular" data-testid={`cc-journey-${entity.tenant_id}-duelater`}>+{s.dueLater}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
